import React from "react";
import { ISearchResults } from "./interface/iSearchResults";
import { AnalyticsContext } from "./context/analyticsContext";
import SearchForm from "./src/searchForm";
import SearchResults from "./src/searchResults";
import AppointmentList from "./src/appointmentList";
import CoachingCountDistribution from "./src/coachingCountDistribution";
import LocationAnalysis from "./src/locationAnalysis";
import Section from "../../../components/section/section";

const AnalyticsContainer = (): React.JSX.Element => {
  const {
    searchResults,
    isLoading,
  }: {
    searchResults: ISearchResults;
    isLoading: boolean;
  } = React.useContext(AnalyticsContext);

  const hasResults =
    !isLoading && searchResults.appointmentList;

  return (
    <Section>
      <SearchForm />
      {hasResults && <SearchResults />}
      {hasResults && <CoachingCountDistribution />}
      {hasResults &&
        searchResults.appointmentList.appointments.length > 0 && (
          <AppointmentList />
        )}
      
      {hasResults && <LocationAnalysis />}
    </Section>
  );
};

export default AnalyticsContainer;
